import React from "react";
import Buscador from "./buscadorColegios/Buscador";

function BuscadorColegios(props) {
  return (
    <Buscador
      searchData={props.searchData}
      handleInscribirEnColegio={props.handleInscribirEnColegio}
      handleMostrarTodos={props.handleMostrarTodos}
      handleAdjuntarDoc={props.handleAdjuntarDoc}
    />
  );
}

export default BuscadorColegios;



// WEBPACK FOOTER //
// ./src/pages/inscripciones/BuscadorColegios.jsx